const REGEX_ALLOWED_ORIGINS = new RegExp(
  '^https://(?:www|dev\\.)?(?:[a-zA-Z0-9-]+\\.)?global-selling.mercadolibre.com|(mercadolibre|mercadolivre|mercadoshops)\\.(?:com|cl)(?:\\.(?:ar|br|co|cl|mx|uy|pe|ec|ve))?(?::8444|:8443|:8445)?(?:/.*)?$',
);

const isAllowedOrigin = () => REGEX_ALLOWED_ORIGINS.test(window.location.origin);

module.exports = isAllowedOrigin;

